<script setup lang="ts">
import Amex from '@clovyr/bed/assets/images/Amex.svg';
import DinersClub from '@clovyr/bed/assets/images/DinersClub.svg';
import Mastercard from '@clovyr/bed/assets/images/Mastercard.svg';
import Visa from '@clovyr/bed/assets/images/Visa.svg';
</script>

<template>
  <div class="stripe">
    <div class="stripe__images">
      <div class="stripe__images-cards">
        <ImageMedia :filename="Mastercard" />
        <ImageMedia :filename="Amex" />
      </div>
      <div class="stripe__images-cards">
        <ImageMedia :filename="DinersClub" />
        <ImageMedia :filename="Visa" />
      </div>
    </div>
    <div class="stripe__text">
      <p class="stripe__heading">Pay via Stripe</p>
      <h4 class="stripe__sub-heading">Credit Card</h4>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/vendor/bootstrap/scss/mixins/breakpoints';

.stripe {
  height: 7rem;
  width: 350px;
  display: flex;
  padding: 8px 36px;
  margin-bottom: 1rem;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 18px;
  border: 1px solid colors.color(grey, secondary);
  background: colors.color(negative, primary);

  @include breakpoints.media-breakpoint-up(md) {
    width: 300px;
    height: 6rem;
    justify-content: flex-start;
  }

  &__images {
    padding: 0.25rem;
  }
  &__text {
    margin-right: 0.5rem;
  }
}

.stripe {
  &__images {
    margin-right: 0.5rem;
  }
  &__images-cards {
    display: flex;

    .image-media:first-child {
      margin-right: 0.15rem;
    }
  }
  &__images-cards:first-child {
    margin-bottom: 0.25rem;
  }
  &__heading {
    font-size: 13px;
  }
}

.stripe:hover {
  cursor: pointer;
}

.stripe:hover {
  background-color: colors.color(grey, primary);
  border: 1px solid colors.color(grey, primary);
}
</style>
